import styled from 'styled-components';
import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';

export const ColorThemeTables = styled.div`
    height: 100%;

    ${colorTheme({
        // ==== Data Row ====

        '--table-data-row-background-hover': {dark: 'var(--blue-13)  ', light: 'var(--blue-02)'},
        '--table-data-row-text-color      ': {dark: 'var(--white-00)    ', light: 'var(--black-01)'},

        '--table-data-row-background-shimmer-odd': {dark: 'var(--blue-14)  ', light: 'var(--blue-14)'},
        '--table-data-row-background-shimmer-even': {dark: 'var(--blue-08)  ', light: 'var(--blue-06)'},
        '--table-data-row-background-shimmer-shine': {dark: 'var(--blue-02)  ', light: 'var(--blue-02)'},

        '--table-data-filter-row-shadow          ': {
            dark: 'var(--shadow-dark-05)',
            light: 'var(--shadow-light-12)',
        },
        '--table-data-row-shadow-hover          ': {
            //
            dark: 'var(--shadow-blue-02)',
            light: 'var(--shadow-blue-01)',
        },

        // ==== Data Header ====
        '--table-header-row-background      ': {dark: 'var(--black-14)  ', light: 'var(--purple-09)'},
        '--table-header-row-text-weight      ': {dark: '300    ', light: '300'},
        '--table-header-row-vertical-padding      ': {dark: '11px    ', light: '11px'},
    })};
`;
